(function () {
  'use strict';

  var cfg               = window.MNM_CONFIG || {};
  var MONEY_FORMAT      = cfg.moneyFormat || '{{amount}}';
  var BUNDLE_NAMES      = cfg.bundleNames || { 1: 'Bundle 1', 2: 'Bundle 2' };
  var BUNDLE_PRICE_CENTS = cfg.bundlePriceCents || { 1: 0, 2: 0 };
  var SECTION_ID        = cfg.sectionId || '';

  var wrap = document.querySelector('[data-section-id="' + SECTION_ID + '"]');
  if (!wrap) return;

  var state = {
    activeBundle: 1,
    limits: {
  1: parseInt(wrap.getAttribute('data-b1-limit'), 10),
  2: parseInt(wrap.getAttribute('data-b2-limit'), 10)
},
    selections: {}
  };

  var grid1        = document.getElementById('mnm-grid-1');
  var grid2        = document.getElementById('mnm-grid-2');
  var typeBtns     = wrap.querySelectorAll('.mnm-type-btn');
  var slotsEl      = document.getElementById('mnm-slots');
  var countEl      = document.getElementById('mnm-count');
  var progressEl   = document.getElementById('mnm-progress');
  var progressFill = document.getElementById('mnm-progress-fill');
  var totalItemsEl = document.getElementById('mnm-total-items');
  var totalPriceEl = document.getElementById('mnm-total-price');
  var priceWasEl   = document.getElementById('mnm-price-was');
  var saveTagEl    = document.getElementById('mnm-save-tag');
  var ctaBtn       = document.getElementById('mnm-cta');
  var ctaText      = document.getElementById('mnm-cta-text');
  var msgEl        = document.getElementById('mnm-msg');

  /* ── Sticky bar elements ────────────────────────── */
  var stickyBar      = document.getElementById('mnm-sticky-bar');
  var barPanel       = document.getElementById('mnm-bar-panel');
  var barSlotsEl     = document.getElementById('mnm-bar-slots');
  var barCountEl     = document.getElementById('mnm-bar-count');
  var barProgressEl  = document.getElementById('mnm-bar-progress');
  var barFillEl      = document.getElementById('mnm-bar-progress-fill');
  var barCtaBtn      = document.getElementById('mnm-bar-cta');
  var barCtaText     = document.getElementById('mnm-bar-cta-text');
  var barToggleBtn   = document.getElementById('mnm-bar-toggle');
  var sectionEl      = document.getElementById('mnm-section-' + SECTION_ID);

  /* ── Money helper ───────────────────────────────── */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return MONEY_FORMAT
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100));
  }

  /* ── State helpers ──────────────────────────────── */
function currentLimit() {
  var limit = state.limits[state.activeBundle];
  return (typeof limit === 'number' && !isNaN(limit) && limit > 0) ? limit : 1;
}
  function totalQty() {
    var t = 0;
    Object.values(state.selections).forEach(function (v) { t += v.qty; });
    return t;
  }

  function actualCostCents() {
    var t = 0;
    Object.values(state.selections).forEach(function (v) { t += v.qty * v.price; });
    return t;
  }

  function bundleUnitCents() {
    return parseInt(BUNDLE_PRICE_CENTS[state.activeBundle], 10) || 0;
  }

  function bundleCount() {
    return Math.floor(totalQty() / currentLimit());
  }

  function isReady() {
    var qty = totalQty();
    return qty > 0 && qty % currentLimit() === 0;
  }

  function setMsg(text, type) {
    if (!msgEl) return;
    msgEl.textContent = text;
    msgEl.className = 'mnm-msg text-sm' + (type ? ' mnm-msg--' + type : '');
  }

  /* ── Render ─────────────────────────────────────── */
  function render() {
    var limit   = currentLimit();
    var qty     = totalQty();
    var pct     = isReady() ? 100 : limit > 0 ? Math.min(((qty % limit) / limit) * 100, 100) : 0;
    var unitC   = bundleUnitCents();
    var bundles = bundleCount();
    var actual  = actualCostCents();

    /* Count */
var displayLimit = Math.max(limit, Math.ceil(qty / limit) * limit);

if (countEl) countEl.textContent = '(' + qty + '/' + displayLimit + ')';
    /* Progress bar (sidebar) */
    if (progressFill) progressFill.style.width = pct + '%';
    if (progressEl)   progressEl.setAttribute('aria-valuenow', Math.round(pct));

    /* Progress bar (sticky bar) */
    if (barFillEl)    barFillEl.style.width = pct + '%';
    if (barProgressEl) barProgressEl.setAttribute('aria-valuenow', Math.round(pct));

    /* Total items */
    if (totalItemsEl) totalItemsEl.textContent = qty;

    /* Bar count */
if (barCountEl) barCountEl.textContent = qty + '/' + displayLimit + ' Products';
    /* ── Pricing ── */
    if (isReady() && unitC > 0) {
      var bundleTotal = unitC * bundles;
      var priceStr    = formatMoney(bundleTotal);
      if (totalPriceEl) totalPriceEl.textContent = priceStr;
      if (actual > bundleTotal) {
        var savePct = Math.round(((actual - bundleTotal) / actual) * 100);
        if (priceWasEl) { priceWasEl.textContent = formatMoney(actual); priceWasEl.hidden = false; }
        if (saveTagEl)  { saveTagEl.textContent  = 'SAVE ' + savePct + '%'; saveTagEl.hidden = false; }
      } else {
        if (priceWasEl) priceWasEl.hidden = true;
        if (saveTagEl)  saveTagEl.hidden  = true;
      }
    } else {
      var runningStr = qty > 0 ? formatMoney(actual) : formatMoney(0);
      if (totalPriceEl) totalPriceEl.textContent = runningStr;
      if (priceWasEl)   priceWasEl.hidden = true;
      if (saveTagEl)    saveTagEl.hidden  = true;
    }

    /* ── CTA text helper ── */
    function ctaLabel() {
  if (isReady()) {
    return 'ADD TO CART';
  }

  var remainder = qty % limit;
  var remaining = remainder === 0 ? limit : (limit - remainder);

  return 'ADD ' + remaining + ' MORE TO COMPLETE';
}

    /* ── Sidebar CTA ── */
    if (ctaBtn) {
      if (isReady()) {
        ctaBtn.disabled = false;
        ctaBtn.setAttribute('aria-disabled', 'false');
        ctaBtn.dataset.state = 'ready';
      } else {
        ctaBtn.disabled = true;
        ctaBtn.setAttribute('aria-disabled', 'true');
        ctaBtn.dataset.state = 'idle';
      }
      if (ctaText) ctaText.textContent = ctaLabel();
    }

    /* ── Bar CTA ── */
    if (barCtaBtn) {
      if (isReady()) {
        barCtaBtn.disabled = false;
        barCtaBtn.setAttribute('aria-disabled', 'false');
        barCtaBtn.dataset.state = 'ready';
      } else {
        barCtaBtn.disabled = true;
        barCtaBtn.setAttribute('aria-disabled', 'true');
        barCtaBtn.dataset.state = 'idle';
      }
      if (barCtaText) barCtaText.textContent = ctaLabel();
    }

    renderSlots();
    syncCards();
  }

  /* ── Slots ──────────────────────────────────────── */
  function buildSlots(target) {
    if (!target) return;
    target.innerHTML = '';
    var filled = Object.keys(state.selections).filter(function (id) {
      return state.selections[id].qty > 0;
    });

    if (filled.length === 0) {
      var empty = document.createElement('div');
      empty.className = 'mnm-slot mnm-slot--empty';
      var icon = document.createElement('span');
      icon.className = 'mnm-slot__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '+';
      empty.appendChild(icon);
      target.appendChild(empty);
      return;
    }

    filled.forEach(function (variantId) {
      var item  = state.selections[variantId];
      var slot  = document.createElement('div');
      slot.className = 'mnm-slot mnm-slot--filled';

      var badge = document.createElement('span');
      badge.className = 'mnm-slot__badge';
      badge.textContent = item.qty;
      badge.setAttribute('aria-label', item.qty + ' selected');
      slot.appendChild(badge);

      if (item.image) {
        var img     = document.createElement('img');
        img.className = 'mnm-slot__img';
        img.src       = item.image;
        img.alt       = item.title;
        img.loading   = 'lazy';
        img.width     = 40;
        img.height    = 44;
        slot.appendChild(img);
      }

      var name = document.createElement('span');
      name.className = 'mnm-slot__name';
      name.textContent = item.title;
      slot.appendChild(name);

      /* Remove button only in sidebar slots, not bar slots */
      if (target === slotsEl) {
        var rmBtn = document.createElement('button');
        rmBtn.type = 'button';
        rmBtn.className = 'mnm-slot__remove';
        rmBtn.setAttribute('aria-label', 'Remove ' + item.title + ' from bundle');
        rmBtn.textContent = '\u00d7';
        rmBtn.addEventListener('click', function () { removeVariant(variantId); });
        slot.appendChild(rmBtn);
      }

      target.appendChild(slot);
    });
  }

  function renderSlots() {
    buildSlots(slotsEl);
    buildSlots(barSlotsEl);
  }

  /* ── Card sync ──────────────────────────────────── */
  function syncCards() {
    wrap.querySelectorAll('.mnm-card[data-grid="' + state.activeBundle + '"]').forEach(function (card) {
      var id      = card.dataset.variantId;
      var qty     = (state.selections[id] && state.selections[id].qty) || 0;
      var addBtn  = card.querySelector('.mnm-add-btn');
      var qtyWrap = card.querySelector('.mnm-card__actions');
      var qtyEl   = card.querySelector('.quantity-selector__input');
      var minus   = card.querySelector('[data-action="decrease"]');

      if (qty > 0) {
        if (addBtn)  addBtn.hidden  = true;
        if (qtyWrap) qtyWrap.hidden = false;
      } else {
        if (addBtn)  addBtn.hidden  = false;
        if (qtyWrap) qtyWrap.hidden = true;
      }

      if (qtyEl)  qtyEl.textContent = qty;
      if (minus)  minus.disabled = qty <= 1;
      card.dataset.selected = qty > 0 ? 'true' : 'false';
    });
  }

  /* ── Qty change ─────────────────────────────────── */
  function changeQty(variantId, delta, card) {
    var current = (state.selections[variantId] && state.selections[variantId].qty) || 0;
    var newQty  = Math.max(0, current + delta);
    if (newQty === 0) {
      delete state.selections[variantId];
    } else {
      state.selections[variantId] = {
        title:     card.dataset.productTitle,
        price:     parseInt(card.dataset.price, 10) || 0,
        image:     card.dataset.image || '',
        qty:       newQty,
        variantId: variantId
      };
    }
    render();
  }

  function removeVariant(variantId) {
    delete state.selections[variantId];
    var card = wrap.querySelector('[data-variant-id="' + variantId + '"][data-grid="' + state.activeBundle + '"]');
    if (card) {
      var addBtn  = card.querySelector('.mnm-add-btn');
      var qtyWrap = card.querySelector('.mnm-card__actions');
      var qtyEl   = card.querySelector('.quantity-selector__input');
      var minus   = card.querySelector('[data-action="decrease"]');
      if (addBtn)  addBtn.hidden  = false;
      if (qtyWrap) qtyWrap.hidden = true;
      if (qtyEl)   qtyEl.textContent = '0';
      if (minus)   minus.disabled = true;
      card.dataset.selected = 'false';
    }
    render();
  }

  /* ── Reset all cards ────────────────────────────── */
  function resetCards() {
    wrap.querySelectorAll('.mnm-card').forEach(function (card) {
      var addBtn  = card.querySelector('.mnm-add-btn');
      var qtyWrap = card.querySelector('.mnm-card__actions');
      var qtyEl   = card.querySelector('.quantity-selector__input');
      var minus   = card.querySelector('[data-action="decrease"]');
      if (addBtn)  addBtn.hidden  = false;
      if (qtyWrap) qtyWrap.hidden = true;
      if (qtyEl)   qtyEl.textContent = '0';
      if (minus)   minus.disabled = true;
      card.dataset.selected = 'false';
    });
  }

  /* ── Switch bundle ──────────────────────────────── */
  function switchBundle(bundleNum) {
    if (bundleNum === state.activeBundle) return;
    state.activeBundle = bundleNum;
    state.selections   = {};
    resetCards();
    grid1.hidden = bundleNum !== 1;
    grid2.hidden = bundleNum !== 2;
    typeBtns.forEach(function (btn) {
      var active = parseInt(btn.dataset.bundle, 10) === bundleNum;
      btn.classList.toggle('mnm-type-btn--active', active);
      btn.classList.toggle('button--outline', !active);
      btn.setAttribute('aria-checked', active ? 'true' : 'false');
    });
    setMsg('');
    render();
  }

  /* ── Add to cart ────────────────────────────────── */
  function addToCart() {
    if (!isReady()) return;

    var label = 'ADDING\u2026';
    if (ctaBtn)    { ctaBtn.dataset.state   = 'loading'; ctaBtn.disabled   = true; }
    if (barCtaBtn) { barCtaBtn.dataset.state = 'loading'; barCtaBtn.disabled = true; }
    if (ctaText)    ctaText.textContent   = label;
    if (barCtaText) barCtaText.textContent = label;
    setMsg('');

    var bundleName = BUNDLE_NAMES[state.activeBundle] || ('Bundle ' + state.activeBundle);
    var limit      = currentLimit();
    var bundles    = bundleCount();

    var items = Object.values(state.selections).map(function (item) {
      return {
        id:         parseInt(item.variantId, 10),
        quantity:   item.qty,
        properties: { '_bundle_type': bundleName, '_bundle_count': bundles, '_bundle_limit': limit }
      };
    });

    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
    .then(function () {
      return fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify({ items: items })
      });
    })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Error'); });
      return res.json();
    })
    .then(function () {
  document.dispatchEvent(new CustomEvent('cart:refresh'));
  setMsg('Bundle added! Opening checkout\u2026', 'success');
  state.selections = {};
  resetCards();
  if (ctaBtn)    { ctaBtn.dataset.state    = 'idle'; ctaBtn.disabled    = true; }
  if (barCtaBtn) { barCtaBtn.dataset.state  = 'idle'; barCtaBtn.disabled  = true; }
  render();
  setTimeout(function () {
  if (flexypeCheckoutActive) {
    openFlexyCheckout();
    // flexyBtn.click();
  } else {
    window.location.href = '/checkout';
  }
}, 300);
})
    .catch(function (err) {
      setMsg(err.message || 'Something went wrong. Please try again.', 'error');
      if (ctaBtn)    { ctaBtn.dataset.state    = 'ready'; ctaBtn.disabled    = false; }
      if (barCtaBtn) { barCtaBtn.dataset.state  = 'ready'; barCtaBtn.disabled  = false; }
    });
  }

  /* ── Sticky bar: IntersectionObserver ───────────── */
  if (stickyBar && sectionEl && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.dataset.visible = entry.isIntersecting ? 'true' : 'false';
        stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'false' : 'true');
      });
    }, { threshold: 0.01, rootMargin: '0px 0px -100px 0px' });
    observer.observe(sectionEl);
  }

  /* ── Sticky bar toggle ──────────────────────────── */
  if (barToggleBtn && barPanel) {
    barToggleBtn.addEventListener('click', function () {
      var expanded = barToggleBtn.getAttribute('aria-expanded') === 'true';
      barToggleBtn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      barPanel.hidden = expanded;
    });
  }

  /* ── Event listeners ────────────────────────────── */
  typeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () { switchBundle(parseInt(btn.dataset.bundle, 10)); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); switchBundle(parseInt(btn.dataset.bundle, 10)); }
    });
  });

  [grid1, grid2].forEach(function (grid) {
    if (!grid) return;
    grid.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('.quantity-selector__button');
      if (qtyBtn) {
        var card = qtyBtn.closest('.mnm-card');
        var id   = card && card.dataset.variantId;
        if (!id) return;
        changeQty(id, qtyBtn.dataset.action === 'increase' ? 1 : -1, card);
        return;
      }
      var removeBtn = e.target.closest('.mnm-remove-btn');
if (removeBtn) {
  var card = removeBtn.closest('.mnm-card');
  var id   = card && card.dataset.variantId;
  if (!id) return;
  removeVariant(id);
  return;
}
      var addBtn = e.target.closest('.mnm-add-btn');
      if (addBtn) {
        var card = addBtn.closest('.mnm-card');
        var id   = card && card.dataset.variantId;
        if (!id) return;
        changeQty(id, 1, card);
      }
    });
  });

  if (ctaBtn)    ctaBtn.addEventListener('click', addToCart);
  if (barCtaBtn) barCtaBtn.addEventListener('click', addToCart);

  /* ── Init ───────────────────────────────────────── */
  render();
})();
